export default __webpack_public_path__ + "static/media/p-5-desktop.baf12c94.png";